import { spacing, Text } from '@scality/core-ui';
import styled from 'styled-components';

/** Matches the charts' plot height, so an empty widget doesn't shrink the dashboard grid. */
const Empty = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: ${spacing.r4};
  min-height: 175px;
  padding: ${spacing.r16};
  text-align: center;
`;

type NoDataProps = {
  /** The widget's own title, kept so the reader knows which one came back empty. */
  title?: string;
  /** Overrides the default wording — e.g. alerts, where empty is good news. */
  message?: string;
};

/**
 * Shown in place of a widget's content when there is nothing to plot. Deliberately not
 * styled like `ErrorWidget`: an empty range is a normal answer, not a broken widget.
 */
export const NoData: React.FC<NoDataProps> = ({ title, message }) => (
  <Empty>
    {title && (
      <Text isEmphazed color="textPrimary">
        {title}
      </Text>
    )}
    <Text variant="Basic" color="textSecondary">
      {message ?? 'No data over this time range.'}
    </Text>
  </Empty>
);
